module.exports = __webpack_public_path__ + "img/5.64921ee1.jpg";